<template>
  <div>

    <button :class="this.btnStyle" class="btn btn-danger open-dialog" data-toggle="modal" :data-target="`#confirmDelete${ this.id }`">
      <i class="fa fa-trash"></i> {{ this.btnText }}
    </button>

    <div class="modal inmodal" :id="`confirmDelete${ this.id }`" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content animated fadeIn">
          <div class="modal-header">

            <button type="button" class="close" data-dismiss="modal" ref="btnClose">
              <span aria-hidden="true">&times;</span><span class="sr-only"></span>
            </button>

            <i class="fa fa-trash modal-icon"></i>
            <h4 class="modal-title">{{ this.title }}</h4>
          </div>

          <div class="modal-body">
            {{ this.text }}
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">
              {{ this.cancelBtnText }}
            </button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click.prevent="confirm()">
              {{ this.confirmBtnText }}
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      id: { type: Number, default: 0 },
      btnStyle: { type: String, default: '' },
      btnText: { type: String, default: 'Excluir' },
      title: { type: String, default: 'Confirmar exclusão' },
      text: { type: String, default: 'Tem certeza que deseja excluir?' },
      confirmBtnText: { type: String, default: 'Sim, excluir!' },
      cancelBtnText: { type: String, default: 'Cancelar' },
    },
    methods: {
      confirm() {
        this.$emit('delete')
      },
    }
  }
</script>

<style scoped>
 .modal-dialog { margin-top: 90px; }
 .modal-footer button { margin-bottom: 5px!important; }
</style>



// WEBPACK FOOTER //
// src/components/layout/ConfirmDeleteBtn.vue